import { render, staticRenderFns } from "./UserNotice.vue?vue&type=template&id=efcb4644&scoped=true&"
import script from "./UserNotice.vue?vue&type=script&lang=js&"
export * from "./UserNotice.vue?vue&type=script&lang=js&"
import style0 from "./UserNotice.vue?vue&type=style&index=0&id=efcb4644&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efcb4644",
  null
  
)

export default component.exports